import { SingleResponse } from "@/src/core/response"
import '@/src/extensions/string'

type HttpMethod = 'GET' | 'POST' | 'PUT' | 'DELETE'
type AuthHeader = 'Authorization' | 'X-App-Token' | 'X-User-Token'

/** Utilizado para fazer cache no lado servidor. */
interface CacheProps {
    cache?: RequestCache
    next?: NextFetchRequestConfig
}

/** Função facilitadora para requisições que retorna um modelo de `SingleResponse<T>`. */
export async function sendRequest<T>(
    appAccessToken: string | undefined,
    url: string,
    method: HttpMethod,
    body?: any,
    accessToken?: string,
    cacheProps?: CacheProps,
    isBearer: boolean = true,
    authName: AuthHeader = 'Authorization'
): Promise<SingleResponse<T>> {
    const response = new SingleResponse<T>()

    try {
        let headers: HeadersInit = {
            'Accept-Charset': 'utf-8',
            [authName]: `${isBearer ? 'Bearer ' : ''}${accessToken ?? appAccessToken}`
        }

        if (method === 'POST' || method === 'PUT')
            headers["Content-Type"] = "application/json; charset=utf-8"

        let fetchOptions: RequestInit = {
            method,
            headers,
            cache: 'no-store',
            ...(body && { body: JSON.stringify(body) }),
        }

        if (cacheProps) {
            fetchOptions = {
                ...fetchOptions,
                cache: cacheProps.cache,
                next: cacheProps.next,
            }
        }

        const apiResponse = await fetch(url, fetchOptions)

        if (apiResponse.ok) {
            if (apiResponse.headers.get('content-type') === "application/json; charset=utf-8") {
                const model = await apiResponse.json() as T
                response.model = model
            }
        } else {
            const errorMessage = await apiResponse.text()
            response.success = false
            response.errorMessage = `${!errorMessage.isNullOrEmpty() ? errorMessage : 'Tivemos um problema ao realizar esta solicitação.'}`
        }
        response.status = apiResponse.status
    } catch (e) {
        response.success = false
        response.errorMessage = e instanceof Error ? e.message : `Erro desconhecido. ${e}`
    }

    return response
}